export default __webpack_public_path__ + "static/media/cards_deal5.69b0267a.mp3";